import React from "react";
import FrameSelectorGroup from "../FrameSelector";
import PlayBar from "../PlayBar";

function PanelFooter(props) {
  const frameSelectorGroup = props.frame.list ? (
    <FrameSelectorGroup
      panelId={props.panelId}
      frameListId={props.frameListId}
      frame={props.frame}
      image={props.image}
    />
  ) : null;

  return (
    <div className="panel-footer">
      {frameSelectorGroup}
      <PlayBar
        playback={props.playback}
        liveMode={props.liveMode}
        nextFrame={props.nextFrame}
        previousFrame={props.previousFrame}
      />
    </div>
  );
}

export default PanelFooter;
